import * as React from 'react';

import logo from '../../assets/images/plex_new.png';
import gettingstarted from '../../assets/images/helpcentericons/startplex.png'
import tipsIcon  from '../../assets/images/helpcentericons/tipsicon.png'
import profileIcon  from '../../assets/images/helpcentericons/profileicon.png'
import usingplexIcon  from '../../assets/images/helpcentericons/usingplex.png'
import './helpCenter.css';

export default class HelpCenter extends React.Component {
    public state = {
        currentTab: 0,
        currentHelpArticle: 0
    }
    constructor(props) {
        super(props);
        this.switchTabContent = this.switchTabContent.bind(this);
        this.createLandingPage = this.createLandingPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCategoryClick = this.handleCategoryClick.bind(this);
        this.createDetailPage = this.createDetailPage.bind(this);
        this.changeCategoryHeading = this.changeCategoryHeading.bind(this);
        this.createHelpArticle = this.createHelpArticle.bind(this);
        this.createArticleList = this.createArticleList.bind(this);
    }

    public componentDidMount(){
        // fetch data 
        // function to render
    }

    // public componentDidUpdate(){
    //     if(this.state.currentHelpArticle > 0) {
    //         this.setState({currentHelpArticle: 0});
    //     }
    // }

    public handleCategoryClick(tab) {
        alert("Category item clicked" + tab);
        this.setState({currentTab: tab});
    }

    public getViewContent() {
        if(this.state.currentTab === 0){
            return this.createLandingPage();
        }else {
            return this.createDetailPage();
        }
    }

    public onHelpItemClick(id){
        alert("Help ITem number: " + id);
        this.setState({currentHelpArticle: id});
    }
    public switchTabContent() {
        if(this.state.currentHelpArticle > 0) {
            return this.createHelpArticle();
        }else{
            return this.createArticleList();
        }
    }
    public createHelpArticle() {
        if(this.state.currentTab > 0) {
            return(
                <div className="hc-subcategory-content">
                    <div className="help-article">
                        <h1 className="holder">This HTML for article number {this.state.currentHelpArticle} is very <span style={{color: "red"}}>Dangerously set!!!:-(</span></h1>
                    </div>
                </div>
            )
        }else{
            return(<div/>);
        }
    }

    public createArticleList() {
        // choose category tab
      if(this.state.currentTab === 1){
        return(
            <div className="hc-subcategory-content">
                <div className="subcategory-holder">
                    <h2 className="subcategory-heading">All about PLEX</h2>
                    <ul>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  1)}>Getting started with PLEX</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  2)}>Getting to know PLEX</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  3)}>Features of PLEX</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  4)}>Why PLEX can help</li>
                    </ul>
                </div>
                <div className="subcategory-holder">
                    <h2 className="subcategory-heading">The PLEX plans</h2>
                    <ul>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  5)}>Which PLEX plan is for you?</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  6)}>What is the difference between plans?</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  7)}>Can I upgrade my plan?</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  8)}>How can I upgrade?</li>
                        <li className="help-item" onClick={this.onHelpItemClick.bind(this,  9)}>What do I do if my payment isn't being processed?</li>
                    </ul>
                </div>
            </div>
        )
        }
        else if(this.state.currentTab === 2) {
            return(
                <div className="hc-subcategory-content">
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">How to get started with PLEX</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  10)}>Simple steps to starting your journey with PLEX</li>
                        </ul>
                    </div>
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">Searching in PLEX</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  11)}>Finding your timetable</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  12)}>Finding your PLOA results</li>
                        </ul>
                    </div>
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">Understanding your PLOA</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  13)}>What is PLOA?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  14)}>How do I complete PLOA?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  15)}>What does my Alert Level mean?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  16)}>What if I think my child answered inaccurately?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  17)}>Can I re-do my PLOA?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  18)}>Can I prent my results?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  19)}>Can two children do the same PLOA?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  20)}>How long does PLOA take to do?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  21)}>How long does it take to get my results?</li>
                        </ul>
                    </div>
                </div>
            )
        }
        else if(this.state.currentTab === 3) {
            return(
                <div className="hc-subcategory-content">
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">Your PLEX account</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  22)}>How to reset your password</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  23)}>How to change your registered email</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  24)}>How to sign in and out</li>
                        </ul>
                    </div>
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">Your PLEX preferences</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  25)}>How to update my notifications</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  26)}>What notifications can I get?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  27)}>Can I integrate my PLEX diary with my personal calendar?</li>
                        </ul>
                    </div>
                </div>
            )
        }
        else if(this.state.currentTab === 4) {
            return(
                <div className="hc-subcategory-content">
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">Top PLEX tips</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  28)}>Shortcuts to find what you need</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  29)}>How to help your friends find the awesomeness that is PLEX</li>
                        </ul>
                    </div>
                    <div className="subcategory-holder">
                        <h2 className="subcategory-heading">PLEX Glossary</h2>
                        <ul>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  30)}>Get to know the PLEX lingo</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  31)}>The things you've asked us and the things we've asked us</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  32)}>Who invented PLEX?</li>
                            <li className="help-item" onClick={this.onHelpItemClick.bind(this,  33)}>What does PLEX stand for?</li>
                        </ul>
                    </div>
                </div>
            )
        }
        
        else if(this.state.currentHelpArticle > 4) {
            return this.createHelpArticle();
        }
        else {
            return(<div/>)
        }
    }

    public changeActiveTab(tab) {
        this.setState({currentTab: tab, currentHelpArticle: 0});
    }

    public changeCategoryHeading() {
        if(this.state.currentTab === 1){
            return(
            <div className="hc-header-content">
                <h1 className="hc-welcome-message">
                    Getting Started
                </h1>
                <p className="hc-header-description">Hello and Welcome to PLEX, let's get started</p>                        
            </div>)
        }
        else if(this.state.currentTab === 2){
           return(
            <div className="hc-header-content">
            <h1 className="hc-welcome-message">
                Using PLEX
            </h1>
            <p className="hc-header-description"><br/></p>                        
        </div>
           )
        }
        else if(this.state.currentTab === 3){
            return(
                <div className="hc-header-content">
                <h1 className="hc-welcome-message">
                    Your Profile
                </h1>
                <p className="hc-header-description">How to make changes to your profile to suit your needs</p>                        
            </div>
            )
        }
        else if(this.state.currentTab === 4){
           return(
            <div className="hc-header-content">
            <h1 className="hc-welcome-message">
                Top Tips
            </h1>
            <p className="hc-header-description">Quick wins to help you get the most out of PLEX</p>                        
        </div>
           )
        }
        else{
            return(<div/>);
        }
        
    }

    public createDetailPage() {
        return(
            <div>
                <section className="hc-landing-header">
                    <div className="header-bar">
                        <div className="header-bar-left">
                            <img className="plex-logo" src={logo} alt="Plex Logo"/>
                            <h1 className="hc-title" onClick={this.changeActiveTab.bind(this, 0)}>Pit Stop</h1>
                        </div>

                        <div className="header-bar-right">
                            <p className="contact-us">Contact Us</p>
                        </div>
                    </div>
                    {this.changeCategoryHeading()}
                </section>

                <section className="custom-tabs">
                    <nav className="hc-custom-nav">
                        <ul className="hc-nav-list">
                            <li className={`hc-nav-item ${this.state.currentTab === 1 ? "current-tab" : ""}`} onClick={this.changeActiveTab.bind(this, 1)}>Getting Started</li>
                            <li className={`hc-nav-item ${this.state.currentTab === 2 ? "current-tab" : ""}`} onClick={this.changeActiveTab.bind(this, 2)}>Using PLEX</li>
                            <li className={`hc-nav-item ${this.state.currentTab === 3 ? "current-tab" : ""}`} onClick={this.changeActiveTab.bind(this, 3)}>Your Profile</li>
                            <li className={`hc-nav-item ${this.state.currentTab === 4 ? "current-tab" : ""}`} onClick={this.changeActiveTab.bind(this, 4)}>Top Tips</li>
                        </ul>
                    </nav>
                </section>

                <section className="hc-category-content">
                                       
                    {this.switchTabContent()}                    
                </section>
            </div>
        )
    }

    public createLandingPage() {
        // first help center page
        return(
            <div>
                <section className="hc-landing-header">
                    <div className="header-bar">
                        <div className="header-bar-left">
                            <img className="plex-logo" src={logo} alt="Plex Logo"/>
                            <h1 className="hc-title" onClick={this.changeActiveTab.bind(this, 0)}>Pit Stop</h1>
                        </div>

                        <div className="header-bar-right">
                            <p className="contact-us">Contact Us</p>
                        </div>
                    </div>
                    <div className="hc-header-content">
                        <h1 className="hc-welcome-message">Welcome to PLEX. How can we help?</h1>
                        <input
                        id="searchvalue"
                        className="custom-textfield"
                        type="text"
                        placeholder="Tell us what we can help you with"
                        onChange={this.handleChange}
                        required={true}
                        data-arg="searchval"
                      />
                      <p className="popular-topics">Popular topics: <span>Popular Item 1</span>, <span>Popular Item 2</span></p>
                    </div>
                </section> 
        

                <section className="hc-categories">
                    <div className="categories-holder">
                        <div onClick = {this.handleCategoryClick.bind(this, 1)} className="category-item">
                            <img className="hc-category-icon" src={gettingstarted} alt="Getting Started"/>
                            <h2 className="hc-category-title">Getting Started</h2>
                            <p className="hc-category-description">Everything you need to know to start using PLEX</p>
                        </div>
                        <div className="category-item" onClick = {this.handleCategoryClick.bind(this, 2)}>
                            <img className="hc-category-icon" src={usingplexIcon} alt="Using Plex"/>
                            <h2 className="hc-category-title">Using Plex</h2>
                            <p className="hc-category-description">Everything you need to know to get the most out of PLEX</p>
                        </div>
                        <div className="category-item" onClick = {this.handleCategoryClick.bind(this, 3)}>
                            <img className="hc-category-icon" src={profileIcon} alt="Your Profile"/>
                            <h2 className="hc-category-title">Your Profile</h2>
                            <p className="hc-category-description">How to make changes to your profile to suit your needs</p>
                        </div>
                        <div className="category-item" onClick = {this.handleCategoryClick.bind(this, 4)}>
                            <img className="hc-category-icon" src={tipsIcon} alt="Top Tips"/>
                            <h2 className="hc-category-title">Top Tips</h2>
                            <p className="hc-category-description">Quick wins to help you get the most out of PLEX</p>
                        </div>
                        {/* <div className="category-item" onClick = {this.handleCategoryClick.bind(this, 2)}>
                            <img className="hc-category-icon" src={gettingstarted} alt="Getting Started"/>
                            <h2 className="hc-category-title">Getting Started</h2>
                            <p className="hc-category-description">Everything you need to know to start using PLEX</p>
                        </div> */}
                    </div>
                </section> 
            </div> 
        )       
    }
    

    public handleChange(event) {
        // handle seach field entry
        const searchValue = event.target.value;
        console.log(searchValue);
    }

    public render() {
        return(
            <div className="help-center">
                {/* navbar here*/}
                {this.getViewContent()}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/HelpCenter/helpCenter.Component.tsx